// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__-3lwu","header":"ReportDetails_header__1k3BK","title":"ReportDetails_title__1L1bm","left":"ReportDetails_left__2cvFh"};